import React from 'react';

import { ObjectDetailPage } from '@/common/components';
import AccessControl from '@/features/access-control';

export const AccessControlPage = () => {
  return (
    <ObjectDetailPage>
      <AccessControl />
    </ObjectDetailPage>
  );
};

export default AccessControlPage;
